<template lang="pug">
  #ch2section1.container-fluid
    .row.d-flex.justify-content-center.align-items-center
      .col-12.col-lg-8.mt-5
        p.d-inline.px-4.py-2.title Lo sexista y vulnerable del autoempleo
      .col-12.col-lg-8
        p.mt-5.text Cuando pensamos en las personas más vulnerables a la pandemia, muchas de nosotras pensamos en personas que viven de tener un pequeño negocio o de llevar a cabo pequeños trabajos de forma independiente y que además no tienen asegurado su ingreso por mucho tiempo: un jardinero, un plomero o una señora que vende quesadillas. Muchas de esas personas clasifican en la definición de autoempleados. Según la Encuesta Nacional de Ocupación y Empleo, del INEGI, los autoempleados en México representan el 23.2% de la población ocupada femenina y el 21.2% de la masculina. Son el segundo grupo más grande, después de las personas que trabajan como empleados remunerados.
        //img(src="/assets/img/chapter2/Blog_Cuarentena_Viral_1_TipoOcupacion.svg")
        #ch2section1-01.group-bars(data-columns="1")
          ch2s1_01
        p.mt-5.text Hay diferencias importantes entre empleados, autoempleados y empleadores. Mientras la mayoría de las personas remuneradas ganan entre uno y tres salarios mínimos, la mayoría de las personas autoempleadas ganan menos de un salario mínimo. Este porcentaje cambia cuando dividimos a la población ocupada mexicana por sexo.
          b Al hacer eso veremos que el 61.1% de las mujeres autoempleadas ganan menos de un salario mínimo, mientras sólo el 43.8% de los hombres autoempleados reportan ganar menos de un salario mínimo.
        p.text En la cuarentena, el sueldo es un tema relevante porque entre más bajo es el sueldo de una persona, menos podrá sobrevivir sin trabajar durante la cuarentena. Además, aquellas personas autoempleadas dependen exclusivamente de su trabajo para vivir y detenerlo implica una amenaza tangible para su vida.
        //img(src="/assets/img/chapter2/Blog_Cuarentena_Viral_2_Sueldo.svg")
        #ch2section1-02.group-bars(data-columns="5")
          ch2s1_02
        #ch2section1-03.group-bars(data-columns="10")
          ch2s1_03
        //img(src="/assets/img/chapter2/Blog_Cuarentena_Viral_3_SueldoSexo.svg")
        p.mt-5.text Según los cálculos del INEGI, casi siempre hay más mujeres autoempleadas que hombres, pero el porcentaje de autoempleados varía mucho por edad. Mientras sólo el 10% de las mujeres menores de 22 años son autoempleadas, 63.2% y 62.4% y 40.5% y 41.2% de quienes tienen de más de 74 o 55 a 74 son autoempleados respectivamente.
        //img(src="/assets/img/chapter2/Blog_Cuarentena_Viral_5._GenOcupacion.svg")
        #ch2section1-04.group-bars(data-columns="8")
          ch2s1_04
        p.mt-5.text Las diferencias en las edades no sólo repercuten en el tipo de trabajo, sino en el sueldo. Mientras el 77% de los autoempleados de más de 74 años y el 56.8% de quienes tienen entre 55 y 73 años reciben menos de un salario mínimo al mes, menos del 50% de quienes tienen menos de 55 lo hacen.
        //img(src="/assets/img/chapter2/Blog_Cuarentena_Viral_4_GenOcupacion.svg")
        #ch2section1-05.group-bars(data-columns="14")
          ch2s1_05
        p.mt-5.text Si vemos el sueldo de las personas de acuerdo con su edad, sexo y estatus laboral en las siguientes gráficas, veremos que entre mayor es la edad de las personas, más aumenta el status de autoempleado como los recuadros tanto de quienes dicen ganar menos de un salario mínimo como de quienes dicen no recibir ingresos.
      .col-12.px-0
        Ch2IncomeSpineplot
      .col-12.col-lg-8
        p.mt-5.text Cabe mencionar también que hay diferencias enormes en el porcentaje de personas autoempleadas en los distintos estados del país. Mientras el 38% de las personas en Oaxaca son autoempleadas, en Coahuila apenas el 13.2% de las personas lo son. El porcentaje de personas autoempleadas por estado, correlaciona también con el porcentaje de pobreza (.90) y pobreza extrema estatal (.92).
        //img(src="/assets/img/chapter2/Blog_Cuarentena_Viral_11_Estado.svg")
        #ch2section1-11.h-group(data-columns="32")
          ch2s1_11
        p.mt-5.text Otro grupo que será fuertemente golpeado por la crisis que se avecina son los pequeños empresarios o quienes tienen un negocio muy pequeño.
          b La mayoría de la población ocupada en México trabaja en microempresas,
          |  es decir, en empresas que tienen menos de 10 personas. Las microempresas, además de ser las más vulnerables a la crisis económica que desatará la pandemia, son las que pagan salarios más bajos a sus trabajadores. Mientras alrededor del 30% de los hombres que trabajan en empresas medianas o grandes ganan más de tres salarios mínimos al mes, sólo alrededor del 10% de quienes trabajan en microempresas lo hacen. Mientras alrededor del 24% de las mujeres que trabajan en empresas medianas o grandes ganan más de tres salarios mínimos al mes, sólo el 5% de quienes trabajan en microempresas lo hacen. Cabe mencionar que esta diferencia se acentúa por género.
        //img(src="/assets/img/chapter2/Blog_Cuarentena_Viral_12_TamSalario.svg")
        #ch2section1-12.group-bars(data-columns="10")
          ch2s1_12
</template>

<script>
import * as d3 from "d3";
import Ch2IncomeSpineplot from "@/components/chapter2/Ch2IncomeSpineplot.vue";
import ch2s1_01 from "@/assets/chapter2/ch2s1_01.vue";
import ch2s1_02 from "@/assets/chapter2/ch2s1_02.vue";
import ch2s1_03 from "@/assets/chapter2/ch2s1_03.vue";
import ch2s1_04 from "@/assets/chapter2/ch2s1_04.vue";
import ch2s1_05 from "@/assets/chapter2/ch2s1_05.vue";
import ch2s1_11 from "@/assets/chapter2/ch2s1_11.vue";
import ch2s1_12 from "@/assets/chapter2/ch2s1_12.vue";

export default {
  name: "Ch2Section1",
  components: {
    ch2s1_01,
    ch2s1_02,
    ch2s1_03,
    ch2s1_04,
    ch2s1_05,
    ch2s1_11,
    ch2s1_12,
    Ch2IncomeSpineplot
  },
  methods: {
    verticalTransitionGroup(entry, observer) {
      if (entry[0].isIntersecting) {
        let data = [],
          id = entry[0].target.id,
          columns = parseInt(entry[0].target.dataset.columns);
        d3.selectAll("#" + id + " svg .group rect").each(function() {
          let rect = d3.select(this);
          data.push({
            y: rect.attr("y"),
            height: rect.attr("height")
          });
        });
        d3.selectAll("#" + id + " svg .group rect")
          .attr("height", "0")
          .attr("y", (d, i) => {
            return (
              Number.parseFloat(data[i].y) + Number.parseFloat(data[i].height)
            );
          })
          .transition()
          .duration(750)
          .ease(d3.easeLinear)
          .delay((d, i) => 750 + Math.floor(i / columns) * 600)
          .attr("height", (d, i) => {
            return data[i].height;
          })
          .attr("y", (d, i) => {
            return data[i].y;
          });
        observer.unobserve(document.querySelector("#" + id));
      }
    }
  },
  mounted() {
    let options = {
      root: null,
      rootMargin: "0px",
      threshold: 0
    };
    let observer = new IntersectionObserver(
      this.verticalTransitionGroup,
      options
    );
    let targets = document.querySelectorAll(".group-bars");
    targets.forEach(t => {
      observer.observe(t);
    });
  }
};
</script>

<style lang="scss">
#ch2section1 {
  .title {
    font-family: Oswald;
    font-size: 30px;
    font-weight: 600;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.06;
    letter-spacing: normal;
    color: #0a1d59;
    background-color: #ffd58a;
  }
  .text {
    font-family: "Inria Sans", sans-serif;
    font-size: 22px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.58;
    letter-spacing: normal;
    color: #0a1d59;
  }
}

@media (max-width: 768px) {
  #ch2section1 {
    .title {
      line-height: 2;
      font-size: 27px;
    }
  }
}
</style>
